/**
 * Caterer Dish Library — preset South + North Indian dishes grouped by meal.
 * Used as Quick-Add autocomplete suggestions inside <CatererMenuCard>.
 * Each entry: { name, meal, region } where meal ∈ tiffin|lunch|snacks|dinner.
 * ~80 dishes total. Vendor can still type any custom dish — this is suggestions.
 */
export const CATERER_DISH_LIBRARY = [
  // ---- TIFFIN (breakfast / morning) ----
  { name: 'Idli', meal: 'tiffin', region: 'south' },
  { name: 'Vada', meal: 'tiffin', region: 'south' },
  { name: 'Plain Dosa', meal: 'tiffin', region: 'south' },
  { name: 'Masala Dosa', meal: 'tiffin', region: 'south' },
  { name: 'Pongal', meal: 'tiffin', region: 'south' },
  { name: 'Upma', meal: 'tiffin', region: 'south' },
  { name: 'Rava Idli', meal: 'tiffin', region: 'south' },
  { name: 'Set Dosa', meal: 'tiffin', region: 'south' },
  { name: 'Onion Uttapam', meal: 'tiffin', region: 'south' },
  { name: 'Idiyappam', meal: 'tiffin', region: 'south' },
  { name: 'Poori Bhaji', meal: 'tiffin', region: 'south' },
  { name: 'Bonda', meal: 'tiffin', region: 'south' },
  { name: 'Aloo Paratha', meal: 'tiffin', region: 'north' },
  { name: 'Paneer Paratha', meal: 'tiffin', region: 'north' },
  { name: 'Methi Thepla', meal: 'tiffin', region: 'north' },
  { name: 'Chole Bhature', meal: 'tiffin', region: 'north' },
  { name: 'Poha', meal: 'tiffin', region: 'north' },
  { name: 'Sabudana Khichdi', meal: 'tiffin', region: 'north' },

  // ---- LUNCH (meals / main course) ----
  { name: 'Sambar Rice', meal: 'lunch', region: 'south' },
  { name: 'Curd Rice', meal: 'lunch', region: 'south' },
  { name: 'Rasam Rice', meal: 'lunch', region: 'south' },
  { name: 'Lemon Rice', meal: 'lunch', region: 'south' },
  { name: 'Tamarind Rice', meal: 'lunch', region: 'south' },
  { name: 'Coconut Rice', meal: 'lunch', region: 'south' },
  { name: 'Veg Biryani', meal: 'lunch', region: 'south' },
  { name: 'Chicken Biryani', meal: 'lunch', region: 'south' },
  { name: 'Mutton Biryani', meal: 'lunch', region: 'south' },
  { name: 'Banana Leaf Veg Meals', meal: 'lunch', region: 'south' },
  { name: 'Avial', meal: 'lunch', region: 'south' },
  { name: 'Kootu Curry', meal: 'lunch', region: 'south' },
  { name: 'Poriyal', meal: 'lunch', region: 'south' },
  { name: 'Chapati', meal: 'lunch', region: 'north' },
  { name: 'Jeera Rice', meal: 'lunch', region: 'north' },
  { name: 'Veg Pulao', meal: 'lunch', region: 'north' },
  { name: 'Dal Tadka', meal: 'lunch', region: 'north' },
  { name: 'Dal Makhani', meal: 'lunch', region: 'north' },
  { name: 'Paneer Butter Masala', meal: 'lunch', region: 'north' },
  { name: 'Palak Paneer', meal: 'lunch', region: 'north' },
  { name: 'Aloo Gobi', meal: 'lunch', region: 'north' },
  { name: 'Chana Masala', meal: 'lunch', region: 'north' },
  { name: 'Rajma', meal: 'lunch', region: 'north' },

  // ---- SNACKS (evening / tea time) ----
  { name: 'Samosa', meal: 'snacks', region: 'north' },
  { name: 'Onion Pakoda', meal: 'snacks', region: 'south' },
  { name: 'Mirchi Bajji', meal: 'snacks', region: 'south' },
  { name: 'Murukku', meal: 'snacks', region: 'south' },
  { name: 'Sundal', meal: 'snacks', region: 'south' },
  { name: 'Mysore Bonda', meal: 'snacks', region: 'south' },
  { name: 'Bhel Puri', meal: 'snacks', region: 'north' },
  { name: 'Pani Puri', meal: 'snacks', region: 'north' },
  { name: 'Aloo Tikki', meal: 'snacks', region: 'north' },
  { name: 'Vada Pav', meal: 'snacks', region: 'north' },
  { name: 'Pav Bhaji', meal: 'snacks', region: 'north' },
  { name: 'Dahi Puri', meal: 'snacks', region: 'north' },
  { name: 'Sev Puri', meal: 'snacks', region: 'north' },
  { name: 'Veg Cutlet', meal: 'snacks', region: 'north' },
  { name: 'Veg Sandwich', meal: 'snacks', region: 'north' },

  // ---- DINNER (night) ----
  { name: 'Parotta', meal: 'dinner', region: 'south' },
  { name: 'Kothu Parotta', meal: 'dinner', region: 'south' },
  { name: 'Veg Kurma', meal: 'dinner', region: 'south' },
  { name: 'Chicken Curry', meal: 'dinner', region: 'south' },
  { name: 'Mutton Curry', meal: 'dinner', region: 'south' },
  { name: 'Egg Curry', meal: 'dinner', region: 'south' },
  { name: 'Appam with Stew', meal: 'dinner', region: 'south' },
  { name: 'Tandoori Roti', meal: 'dinner', region: 'north' },
  { name: 'Butter Naan', meal: 'dinner', region: 'north' },
  { name: 'Garlic Naan', meal: 'dinner', region: 'north' },
  { name: 'Rumali Roti', meal: 'dinner', region: 'north' },
  { name: 'Kadai Paneer', meal: 'dinner', region: 'north' },
  { name: 'Shahi Paneer', meal: 'dinner', region: 'north' },
  { name: 'Malai Kofta', meal: 'dinner', region: 'north' },
  { name: 'Butter Chicken', meal: 'dinner', region: 'north' },
  { name: 'Tandoori Chicken', meal: 'dinner', region: 'north' },
  { name: 'Gulab Jamun', meal: 'dinner', region: 'north' },
  { name: 'Rasgulla', meal: 'dinner', region: 'north' },
  { name: 'Payasam', meal: 'dinner', region: 'south' },
  { name: 'Kheer', meal: 'dinner', region: 'north' },
  { name: 'Mysore Pak', meal: 'dinner', region: 'south' },
  { name: 'Jalebi', meal: 'dinner', region: 'north' },
];

export const MEAL_OPTIONS = [
  { key: 'tiffin', label: 'Tiffin', tone: 'amber', hint: 'Breakfast / morning' },
  { key: 'lunch', label: 'Lunch', tone: 'orange', hint: 'Meals / main course' },
  { key: 'snacks', label: 'Snacks', tone: 'pink', hint: 'Evening / tea-time' },
  { key: 'dinner', label: 'Dinner', tone: 'indigo', hint: 'Night' },
];
